import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/highlightBox";

const add = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/add", payload);
}

const edit = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const saveDisplay = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/saveDisplay", payload);
}

// NMU-419: userGroup scopes the call to one of the 5 audience tabs.
const getDisplay = (payload = {}) => {
    return httpUtils.post(SERVICE_NAME + "/getDisplay", payload);
}

const highlightBoxApi = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
}

export default highlightBoxApi;